import { withGTM } from '@/features/shared/HOCs';
import { resolveBool, resolveImage, resolveLink, resolveSpacingSize } from '@/utils/resolvers';
import React, { useRef } from 'react';
import CMSWrapper from '../shared/CMSWrapper';
import CampaignHeader from './CampaignHeader';
import {
  mapTarget,
  onDatalayer,
  onDatalayerClickCTA,
  onDatalayerClickLink,
} from './CampaignHeader.datalayer';

const MappedCampaignHeader = ({
  content,
  presentation,
  languagesList,
  config,
  labels,
  pageModels,
  isPreview,
  contentButtons,
}: any) => {
  const { config: globalConfig, languageConfig } = pageModels || {};

  const {
    elasticsearch: elasticsearchConfig,
    marketo: marketoConfig,
    translation: translationConfig,
  } = globalConfig || {};

  return (
    <div
      data-datalayer-position="campaign_header"
      data-datalayer-variant={presentation?.datalayerVariant}
    >
      <CampaignHeader
        isSticky={!isPreview}
        content={content}
        presentation={presentation}
        languages={languagesList}
        config={config}
        labels={labels}
        elasticsearchConfig={elasticsearchConfig}
        // web-components don't use marketo stuff.
        marketoConfig={marketoConfig}
        contentButtons={contentButtons}
        translationConfig={translationConfig}
        languageConfig={languageConfig}
      />
    </div>
  );
};
const resolveButton = ({ rawVal, page, pageModels }: any) => {
  const buttons = Array.isArray(rawVal) ? rawVal : [rawVal];
  return buttons.map((btn) => resolveLink({ rawVal: btn, page, pageModels }));
};

const MappedCampaignHeaderGTM = withGTM({
  Component: MappedCampaignHeader,
  onDatalayer,
  config: { mapTarget },
});
const GlobalHeaderContainerGlobal = withGTM({
  Component: MappedCampaignHeaderGTM,
  onDatalayer: onDatalayerClickLink,
  config: { eventName: 'gtm:click:link', isCustom: true },
});
const GlobalHeaderContainerGTM = withGTM({
  Component: GlobalHeaderContainerGlobal,
  onDatalayer: onDatalayerClickCTA,
  config: { eventName: 'gtm:click:cta', isCustom: true },
});

const CampaignHeaderCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        logoOne: [null, resolveImage],
        logoTwo: [null, resolveImage],
        logoThree: [null, resolveImage],
        button: ['buttons', resolveButton],
      },
    ],
    'globalHeader.config': 'config',
    'globalHeader.labels': 'labels',
    componentParameterMap: [
      'presentation',
      {
        containerBottomSpacing: [null, resolveSpacingSize],
        includeJumplinks: [null, resolveBool],
        includeLanguageDropdown: [null, resolveBool],
        isTransparent: [null, resolveBool],
        'variant-label': 'datalayerVariant',
      },
    ],
    'navigation/language/languages-value-list': 'languagesList',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={GlobalHeaderContainerGTM}
      mapping={mapping.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default CampaignHeaderCMSWrapper;
